module.exports = __webpack_public_path__ + "static/poster-DEI-croirelesvictimes-apercu-1200-05fa95298c5d0ec729953655098ff7c6.png";